import React from 'react';
import ContainerHead from 'src/components/ui/ContainerOverlay/ContainerHead/ContainerHead';
import { useTranslation } from 'react-i18next';
import Modal from '../../layouts/Modal/Modal';

export type DeliveryStatusModalProps = {
  isOpen: boolean;
  onClose: () => void;
  status: string | null | undefined;
};

const DeliveryStatusModal: React.FC<DeliveryStatusModalProps> = ({ isOpen, onClose, status }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ContainerHead>
        <div className="flex justify-center items-center w-full h-full">
          <p className="typo-text-16--bold">{t(`status.${status}`)}</p>
        </div>
      </ContainerHead>
      <div className="w-full max-w-xl surface-elevated rounded-lg shadow-lg p-32 text-center mx-auto">
        <p className="typo-text-16--bold mb-8">{t('general.information')}</p>
        <p className="typo-text-16 text-faded">{t(`status.${status}_description`)}</p>
      </div>
    </Modal>
  );
};

export default DeliveryStatusModal;
